<template>
  <div class="page-start">
    <mdb-container fluid class="mt-4">


      <mdb-row v-if="announcement">
        <mdb-col class="pr-0" col="10" offset="1">
          <mdb-card class="cards h-100">
            <mdb-card-body>
              <mdb-card-title class="black white-text p-2">Announcement</mdb-card-title>
              <div style="text-align: left;  white-space: pre-line;">
                {{ announcement }}
              </div>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row><br>

      <mdb-row>
        <mdb-col class="pr-0" col="10" offset="1">
          <iframe class="d-none d-sm-block d-md-block" src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&showTitle=0&showPrint=0&showTabs=0&showCalendars=0&src=ODJlZmJvdG91MHRjcGFoODI1NnR2ZW80b29AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%238E24AA&color=%230B8043" style="border:solid 1px #777; position: relative !important; width: 100% !important; height: 43.75em !important;" frameborder="0" scrolling="no"></iframe>
        </mdb-col>
      </mdb-row>
      <br>

      <!--
      <mdb-row>
        <mdb-col class="pr-0" col="5" offset="1">
          <mdb-card class="cards h-100">
            <mdb-card-body>
              <mdb-card-title class="black white-text p-2">Employee Spotlight</mdb-card-title>
							<img :src="spotlightPhoto" class="rounded-circle img-fluid pb-2" style="height: 250px"/>
              <mdb-card-text>
								<h3>{{ spotlightTitle }}</h3><br>
								{{ spotlightDesc }}
							</mdb-card-text> 
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
        <mdb-col class="pr-0" col="5">
          <mdb-card class="cards h-100">
            <mdb-card-body>
              <mdb-card-title class="black white-text p-2">Book Of The Month</mdb-card-title>
							<img :src="bookOfTheMonthPhoto" class="img-fluid pb-2" style="height: 250px"/>
              <mdb-card-text>
								<h3>{{ bookOfTheMonthTitle }}</h3><br>
								{{ bookOfTheMonthDesc }}
							</mdb-card-text>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <br>
      -->
      <mdb-row class="container-fluid justify-content-center m-0">
        <mdb-col col="12 carousel-contain d-block d-md-none m-0">
          <mdb-carousel class="carousel-image" style="background-color: #000000" :items="basicCarousel" :interval="8000" indicators controlls></mdb-carousel>
        </mdb-col>
        <mdb-col col="10 carousel-contain d-none d-md-block m-0">
          <mdb-carousel class="carousel-image" style="background-color: #000000" :items="basicCarousel" :interval="8000" indicators controlls></mdb-carousel>
        </mdb-col>
      </mdb-row>
      <br>
    </mdb-container>
  </div>
</template>

<style>
  .messages{
    height: 150px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  div.carousel-inner img {
    height: 90vh !important;
    max-width: 1516px !important;
    object-fit: contain !important;
  }
  @media screen and (max-width: 800px) {
    div.carousel-inner img {
      height: 50vh !important; 
    }
    .carousel-contain{
      width: 100% !important;
    }
  }
</style>

<script>
  //import axios from 'axios';
	import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import {
    mdbCarousel,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    //mdbCardText
  } from "mdbvue";

export default {
  name: 'Home-Export',
  components: {
    mdbCarousel,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    //mdbCardText
  },
  data() {
    return {
      basicCarousel: [],
			/*spotlightTitle: '',
			spotlightDesc: '',
			spotlightPhoto: '',
			bookOfTheMonthTitle: '',
			bookOfTheMonthDesc: '',
			bookOfTheMonthPhoto: '',*/
      announcement: '',
    }
  },

	methods: 
	{

    //===========================================================================================
		//	Method Name	:	populateHome
		//	
		//  Parameters
		//  Name										Type						Direction		Description
		//  ----------------------	--------------	---------		-------------------------------------
		//  Return Value            void            n/a         n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Fetches the homepage media and section information and populates the data() object
		//===========================================================================================
		populateHome: async function()
		{
			let token = this.$store.getters.getToken;
      let builtQuery = "sort[0]=id:asc&populate[1]=spotlightPhoto&populate[2]=bookOfTheMonthPhoto&populate[3]=carousel";
			let response = await DatabaseLib.getRequest('strapiDatabase','home-pages',token, builtQuery);
			/*this.spotlightTitle = response.data.data[0].attributes.spotlightTitle;
			this.spotlightDesc = response.data.data[0].attributes.spotlightDescription;
			this.spotlightPhoto = DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + response.data.data[0].attributes.spotlightPhoto.data.attributes.url;
			this.bookOfTheMonthTitle = response.data.data[0].attributes.bookOfTheMonthTitle;
			this.bookOfTheMonthDesc = response.data.data[0].attributes.bookOfTheMonthDesc;
			this.bookOfTheMonthPhoto = DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + response.data.data[0].attributes.bookOfTheMonthPhoto.data.attributes.url;
      */
      this.announcement = response.data.data[0].attributes.announcement;

      for (let i = 0; i < response.data.data[0].attributes.carousel.data.length; i = i + 1) {
        this.basicCarousel.push({img: true, src: DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + response.data.data[0].attributes.carousel.data[i].attributes.url});
      }

		},
	},
  
	mounted() 
	{
    //this.getRedirect();
    this.populateHome();
	}
};
</script>

<style>
@media (max-width: 550px) {
  .big-container {
      display: none;
  }
}
@media (min-width: 550px) {
  .small-container {
      display: none;
  }
}

.nav-link {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  color: white !important;
}
</style>
